<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Date Ranges</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.frDate"
                            :label="filtersLabel.frDate"
                            :error-messages="errors.collect('frDate')"
                            data-vv-name="frDate"
                            :data-vv-as="filtersLabel.frDate"
                            v-validate="'required'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.toDate"
                            :label="filtersLabel.toDate"
                            :error-messages="errors.collect('toDate')"
                            data-vv-name="toDate"
                            :data-vv-as="filtersLabel.toDate"
                            v-validate="'required'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6>
                          <cal-picker
                            v-model="filters.transDate"
                            :label="filtersLabel.transDate"
                            :error-messages="errors.collect('transDate')"
                            data-vv-name="transDate"
                            :data-vv-as="filtersLabel.transDate"
                            v-validate="'required'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg6 xs6> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Fund -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.fund"
                            :label="filtersLabel.fund"
                            item-text="label"
                            item-value="value"
                            data-vv-name="fund"
                            :data-vv-as="filtersLabel.fund"
                            :error-messages="errors.collect('fund')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.fund === 'Selected'">
                          <v-autocomplete
                            :items="fundList"
                            v-model="filters.selectedFund"
                            :label="filtersLabel.selectedFund"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedFund"
                            :data-vv-as="filtersLabel.selectedFund"
                            :error-messages="errors.collect('selectedFund')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Branch -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.branch"
                            :label="filtersLabel.branch"
                            item-text="label"
                            item-value="value"
                            data-vv-name="branch"
                            :data-vv-as="filtersLabel.branch"
                            :error-messages="errors.collect('branch')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.branch === 'Selected'">
                          <v-autocomplete
                            :items="branchList"
                            v-model="filters.selectedBranch"
                            :label="filtersLabel.selectedBranch"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedBranch"
                            :data-vv-as="filtersLabel.selectedBranch"
                            :error-messages="errors.collect('selectedBranch')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Business Source -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.busSrc"
                            :label="filtersLabel.busSrc"
                            item-text="label"
                            item-value="value"
                            data-vv-name="busSrc"
                            :data-vv-as="filtersLabel.busSrc"
                            :error-messages="errors.collect('busSrc')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.busSrc === 'Selected'">
                          <v-autocomplete
                            :items="busSrcList"
                            v-model="filters.selectedBusSrc"
                            :label="filtersLabel.selectedBusSrc"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedBusSrc"
                            :data-vv-as="filtersLabel.selectedBusSrc"
                            :error-messages="errors.collect('selectedBusSrc')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Department -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.dept"
                            :label="filtersLabel.dept"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dept"
                            :data-vv-as="filtersLabel.dept"
                            :error-messages="errors.collect('dept')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.dept === 'Selected'">
                          <v-autocomplete
                            :items="deptList"
                            v-model="filters.selectedDept"
                            :label="filtersLabel.selectedDept"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedDept"
                            :data-vv-as="filtersLabel.selectedDept"
                            :error-messages="errors.collect('selectedDept')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Policy Type -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.polType"
                            :label="filtersLabel.polType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polType"
                            :data-vv-as="filtersLabel.polType"
                            :error-messages="errors.collect('polType')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.polType === 'Selected'">
                          <v-autocomplete
                            :items="polTypeList"
                            v-model="filters.selectedPolType"
                            :label="filtersLabel.selectedPolType"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedPolType"
                            :data-vv-as="filtersLabel.selectedPolType"
                            :error-messages="errors.collect('selectedPolType')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Motor Trade Class -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="allSelectedList"
                            v-model="filters.mtrTradeCls"
                            :label="filtersLabel.mtrTradeCls"
                            item-text="label"
                            item-value="value"
                            data-vv-name="mtrTradeCls"
                            :data-vv-as="filtersLabel.mtrTradeCls"
                            :error-messages="errors.collect('mtrTradeCls')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-if="filters.mtrTradeCls === 'Selected'">
                          <v-autocomplete
                            :items="mtrTradeClsList"
                            v-model="filters.selectedMtrTradeCls"
                            :label="filtersLabel.selectedMtrTradeCls"
                            item-text="label"
                            item-value="value"
                            multiple
                            data-vv-name="selectedMtrTradeCls"
                            :data-vv-as="filtersLabel.selectedMtrTradeCls"
                            :error-messages="errors.collect('selectedMtrTradeCls')"
                            v-validate="'required'"
                            :loading="loading"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6 v-else></v-flex>
                        <!-- Direct / RI Inwards -->
                        <v-flex lg6 xs6>
                          <v-autocomplete
                            :items="dRiList"
                            v-model="filters.dRi"
                            :label="filtersLabel.dRi"
                            item-text="label"
                            item-value="value"
                            data-vv-name="dRi"
                            :data-vv-as="filtersLabel.dRi"
                            :error-messages="errors.collect('dRi')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn color="info" dark :loading="submitting" @click.prevent="doExport">
            {{ filtersLabel.export }}
            <v-icon dark right>mdi-clipboard-text</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="submitting" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...{{ submitLabel }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { downloadPrompt } from '@/utils/file'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      filters: {
        frDate: null,
        toDate: null,
        transDate: null,
        fund: null,
        selectedFund: null,
        branch: null,
        selectedBranch: null,
        busSrc: null,
        selectedBusSrc: null,
        dept: null,
        selectedDept: null,
        polType: null,
        selectedPolType: null,
        mtrTradeCls: null,
        selectedMtrTradeCls: null,
        dRi: null
      },
      filtersLabel: {
        frDate: 'For the Period',
        toDate: 'to',
        transDate: 'Transmission Date to LTA',
        fund: 'Fund',
        branch: 'Branch',
        busSrc: 'Business Source',
        dept: 'Department',
        polType: 'Policy Type',
        mtrTradeCls: 'Motor Trade Class',
        dRi: 'Direct / RI Inwards',
        selectedFund: 'Selected Fund',
        selectedBranch: 'Selected Branch',
        selectedBusSrc: 'Selected Business Source',
        selectedDept: 'Selected Department',
        selectedPolType: 'Selected Policy Type',
        selectedMtrTradeCls: 'Selected Motor Trade Class',
        export: 'Export'
      },
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      fundList: [],
      branchList: [],
      busSrcList: [],
      deptList: [],
      polTypeList: [],
      mtrTradeClsList: [],
      dRiList: [
        {
          label: 'Both',
          value: 'Both'
        },
        {
          label: 'Direct',
          value: 'Direct'
        },
        {
          label: 'RI Inwards',
          value: 'Inwards'
        }
      ],
      loading: false,
      showErrorDialog: false,
      submitting: false,
      submitLabel: undefined,
      panel1: [0]
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    doInit() {
      this.filters.toDate = new Date()
      this.filters.transDate = new Date()
      this.filters.fund = 'All'
      this.filters.branch = 'All'
      this.filters.busSrc = 'All'
      this.filters.dept = 'All'
      this.filters.polType = 'All'
      this.filters.mtrTradeCls = 'All'
      this.filters.dRi = 'Direct'
      this.getDownloadMotorPoliciesLTA()
    },
    async getDownloadMotorPoliciesLTA() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadMotorPoliciesLTA
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          if (result.data.fundList) {
            this.$set(this, 'fundList', result.data.fundList)
          }
          if (result.data.branchList) {
            this.$set(this, 'branchList', result.data.branchList)
          }
          if (result.data.busSrcList) {
            this.$set(this, 'busSrcList', result.data.busSrcList)
          }
          if (result.data.deptList) {
            this.$set(this, 'deptList', result.data.deptList)
          }
          if (result.data.polTypeList) {
            this.$set(this, 'polTypeList', result.data.polTypeList)
          }
          if (result.data.mtrTradeClsList) {
            this.$set(this, 'mtrTradeClsList', result.data.mtrTradeClsList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doDownloadLTA()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doDownloadLTA() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTATxt
      if (apiUrl) {
        try {
          this.submitting = true
          await this.$http.post(apiUrl, this.filters)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    _doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doDownloadLTA().then(() => {
            this.doDownloadAudit4().then(() => {
              this.doDownloadAudit3().then(() => {
                this.doDownloadAudit2().then(() => {
                  this.doDownloadAudit1()
                })
              })
            })
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async _doDownloadLTA() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTATxt
      if (apiUrl) {
        try {
          this.submitting = true
          this.submitLabel = 'Text File'
          const result = await this.$http.post(apiUrl, this.filters)

          if (result.data) {
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            downloadPrompt(blob, filename)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doDownloadAudit4() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTAAud4
      if (apiUrl) {
        try {
          this.submitting = true
          this.submitLabel = 'Audit File 4'
          const expand = {
            frDate: this.filters.frDate,
            toDate: this.filters.toDate,
            transDate: this.filters.transDate,
            fund: this.filters.fund,
            selectedFund: this.filters.selectedFund,
            branch: this.filters.branch,
            selectedBranch: this.filters.selectedBranch,
            busSrc: this.filters.busSrc,
            selectedBusSrc: this.filters.selectedBusSrc,
            dept: this.filters.dept,
            selectedDept: this.filters.selectedDept,
            polType: this.filters.polType,
            selectedPolType: this.filters.selectedPolType,
            mtrTradeCls: this.filters.mtrTradeCls,
            selectedMtrTradeCls: this.filters.selectedMtrTradeCls,
            dRi: this.filters.dRi
          }

          const result = await this.$http.get(expandURI(apiUrl, expand), {
            responseType: 'blob'
          })

          if (result.data) {
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            var allowDownload = (headers['content-disposition'] || 'file').split('allowDownload=')[1]
            if (allowDownload.substring(0, 1) === '1') {
              downloadPrompt(blob, filename)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doDownloadAudit3() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTAAud3
      if (apiUrl) {
        try {
          this.submitting = true
          this.submitLabel = 'Audit File 3'
          const expand = {
            frDate: this.filters.frDate,
            toDate: this.filters.toDate,
            transDate: this.filters.transDate,
            fund: this.filters.fund,
            selectedFund: this.filters.selectedFund,
            branch: this.filters.branch,
            selectedBranch: this.filters.selectedBranch,
            busSrc: this.filters.busSrc,
            selectedBusSrc: this.filters.selectedBusSrc,
            dept: this.filters.dept,
            selectedDept: this.filters.selectedDept,
            polType: this.filters.polType,
            selectedPolType: this.filters.selectedPolType,
            mtrTradeCls: this.filters.mtrTradeCls,
            selectedMtrTradeCls: this.filters.selectedMtrTradeCls,
            dRi: this.filters.dRi
          }

          const result = await this.$http.get(expandURI(apiUrl, expand), {
            responseType: 'blob'
          })

          if (result.data) {
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            var allowDownload = (headers['content-disposition'] || 'file').split('allowDownload=')[1]
            if (allowDownload.substring(0, 1) === '1') {
              downloadPrompt(blob, filename)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doDownloadAudit2() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTAAud2
      if (apiUrl) {
        try {
          this.submitting = true
          this.submitLabel = 'Audit File 2'
          const expand = {
            frDate: this.filters.frDate,
            toDate: this.filters.toDate,
            transDate: this.filters.transDate,
            fund: this.filters.fund,
            selectedFund: this.filters.selectedFund,
            branch: this.filters.branch,
            selectedBranch: this.filters.selectedBranch,
            busSrc: this.filters.busSrc,
            selectedBusSrc: this.filters.selectedBusSrc,
            dept: this.filters.dept,
            selectedDept: this.filters.selectedDept,
            polType: this.filters.polType,
            selectedPolType: this.filters.selectedPolType,
            mtrTradeCls: this.filters.mtrTradeCls,
            selectedMtrTradeCls: this.filters.selectedMtrTradeCls,
            dRi: this.filters.dRi
          }

          const result = await this.$http.get(expandURI(apiUrl, expand), {
            responseType: 'blob'
          })

          if (result.data) {
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            var allowDownload = (headers['content-disposition'] || 'file').split('allowDownload=')[1]
            if (allowDownload.substring(0, 1) === '1') {
              downloadPrompt(blob, filename)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doDownloadAudit1() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.downloadLTAAud1
      if (apiUrl) {
        try {
          this.submitting = true
          this.submitLabel = 'Audit File 1'
          const expand = {
            frDate: this.filters.frDate,
            toDate: this.filters.toDate,
            transDate: this.filters.transDate,
            fund: this.filters.fund,
            selectedFund: this.filters.selectedFund,
            branch: this.filters.branch,
            selectedBranch: this.filters.selectedBranch,
            busSrc: this.filters.busSrc,
            selectedBusSrc: this.filters.selectedBusSrc,
            dept: this.filters.dept,
            selectedDept: this.filters.selectedDept,
            polType: this.filters.polType,
            selectedPolType: this.filters.selectedPolType,
            mtrTradeCls: this.filters.mtrTradeCls,
            selectedMtrTradeCls: this.filters.selectedMtrTradeCls,
            dRi: this.filters.dRi
          }

          const result = await this.$http.get(expandURI(apiUrl, expand), {
            responseType: 'blob'
          })

          if (result.data) {
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            var allowDownload = (headers['content-disposition'] || 'file').split('allowDownload=')[1]
            if (allowDownload.substring(0, 1) === '1') {
              downloadPrompt(blob, filename)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
